import { Component, effect, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { NormalizeString } from '@webapp/core';
import { RiskListComponent } from '@webapp/core/ui/components/risks/risk-list/risk-list.component';
import { IRisk } from '../interfaces/quoter.interface';
import { RiskListStore } from '../store/risk-list-store.service';
import { QuoterStoreService } from '../store/quoter-store.service';
import { IUser } from '@webapp/users/interfaces/users.interface';
import { ShowForRoleDirective } from '@webapp/core/directives/showForRole';
import { SelectedAgentComponent } from '../ui/components/selected-agent/selected-agent.component';
import { ProducerSelectorModalComponent } from '../ui/components/producer-selector-modal/producer-selector-modal.component';


@Component({
  selector: 'app-quoter-page',
  standalone: true,
  imports: [RiskListComponent, ShowForRoleDirective, SelectedAgentComponent, ProducerSelectorModalComponent],
  templateUrl: './quoter-page.component.html',
  styleUrl: './quoter-page.component.scss',
})
export class QuoterPageComponent {
  private readonly router = inject(Router);
  private readonly riskListStore = inject(RiskListStore);
  private quoterStateService = inject(QuoterStoreService);
  readonly quoterState = this.quoterStateService.state.asReadonly();
  risks = signal<IRisk[]>([]);
  loading = signal(false);
  readonly error = this.riskListStore.error;

  constructor() {
    effect(() => {
      this.getRisks();
    });
  }

  private async getRisks() {
    this.loading.set(true);
    // No options → unfiltered: preserves apps/agents' show-all-risks behavior (D7).
    // RiskListStore.loadRisks() never rejects — HTTP failures are caught internally
    // and surfaced via the `error` signal (exposed above), so there is nothing to
    // catch/rethrow here.
    await this.riskListStore.loadRisks();
    const risks = this.riskListStore.risks();
    risks.map((risk) => {
      risk.link = NormalizeString(risk.name);
      risk.icon = `${risk.tag}`;
    });
    this.risks.set(risks);
    this.loading.set(false);
  }

  setRisk(risk: IRisk) {
    localStorage.setItem('activar_risk', JSON.stringify(risk));
    this.quoterStateService.set('risk', risk);
    this.router.navigateByUrl(`cotizar/${risk.link}`);
  }

  setAgent(agent: IUser){
   this.quoterStateService.set('agent', agent);
  }
  clearUser() {
    this.quoterStateService.set('agent', {} as IUser);
  }
}
